module.exports = __webpack_public_path__ + "img/certificateDeliver.e3898ef6.svg";